import { LDFlagSet } from 'launchdarkly-node-server-sdk';
import { createContext, useContext } from 'react';

export const LDFlagsContext = createContext({});

export const useLDFlags = (): LDFlagSet => useContext(LDFlagsContext);
